module.exports = __webpack_public_path__ + "static/aislynn1-6b4866e1e2f13dc5daab082f88dda393.png";